module.exports = __webpack_public_path__ + "media/logo/logo_caradamedica-55193bc5.png";